import { createSlice } from '@reduxjs/toolkit';
import { getCookie, decodeJwt } from '../../utilities';
import { ADMIN_TOKEN_COOKIE_NAME } from '../../constants';

const buildAdminAuthState = () => {
  const token = getCookie(ADMIN_TOKEN_COOKIE_NAME);
  const decoded = token ? decodeJwt(token) : null;
  return {
    adminLoggedIn: !!token,
    adminUser: decoded
  };
};

const initialState = buildAdminAuthState();

export const adminAuthSlice = createSlice({
  initialState,
  name: 'adminAuth',
  reducers: {
    adminLoginSuccess: (state, action) => {
      const { payload } = action;
      return {
        ...state,
        adminLoggedIn: true,
        adminUser: payload
      };
    },
    adminLogout: () => ({
      adminLoggedIn: false,
      adminUser: null
    })
  }
});

export const { adminLoginSuccess, adminLogout } = adminAuthSlice.actions;

export default adminAuthSlice.reducer;
